module.exports = __webpack_public_path__ + "img/icon_akunblack.f1bf2ab1.png";